
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"21","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"clip-path":"url(#clip0_8831_1208)"}},[_c('path',{attrs:{"d":"M3.47 7.47a.75.75 0 111.06 1.06l-.72.72H19a.75.75 0 010 1.5H3.81l.72.72a.75.75 0 11-1.06 1.06L.94 10l2.53-2.53z","fill":"#20365C"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_8831_1208"}},[_c('path',{attrs:{"fill":"#fff","transform":"matrix(-1 0 0 1 20.5 0)","d":"M0 0h20v20H0z"}})])])])
      }
    
      }
    